<template>
<div style="position:relative;" @mouseover="onChartMouseover" @mouseleave="onChartMouseleave">
  <w-analysis-chart-tool :visible="showTool" :rsc-info-list="chartRscInfoList"/>
  <highcharts class="chart" :options="options" ref="highchart" />
  <el-scrollbar class="status">
    <ul class="list list-event">
      <li v-for="point in legendPoints" :key="point.key" :class="getLegendClass(point.series)" :style="{borderColor: point.color}" >
        <span class="number">{{ convertValuByUnit(point) }}</span>
        <span class="content" @click="onClickLegend(point.series)">
          <strong v-if="showObjName">{{ convertObjName(point.series) }}</strong>
          <span>{{ convertLegendName(point.series) }}</span>
        </span>
      </li>
    </ul>
  </el-scrollbar>
</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { lineOptions } from '@/constants/chart-options';
import { plotCharts } from '@/mixins/performance/charts';
import WAnalysisChartTool from './AnalysisChartTool';

export default {
  name: 'WPlotLineChart',
  mixins: [plotCharts],
  components: {
    WAnalysisChartTool,
  },
  props: {
    visible: {
      type: Boolean,
    },
    rscInfoList: {
      type: Array,
    },
    objInfo: {
      type: Object,
    },
    showObjName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTool: false,
      options: cloneDeep(lineOptions),
    };
  },
  methods: {
    onChartMouseover() {
      this.showTool = true;
    },
    onChartMouseleave() {
      this.showTool = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/PlotLineChart.vue